import React from 'react';
function DetachGlobal({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <rect width="6.5" height="6.5" x="12.5" y="13.879" rx="1.3" />
      <rect width="6.5" height="6.5" x="14.75" y="3" rx="1.3" transform="rotate(30 14.75 3)" />
      <rect width="6.5" height="6.5" x="3" y="13.879" rx="1.3" />
      <rect width="6.5" height="6.5" x="3" y="4.281" rx="1.3" />
    </svg>
  );
}

export default DetachGlobal;
